// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/avatar/style/index.less
// module id = 1006
// module chunks = 0